import { Link } from 'react-router';

import { getBlogBreadcrumbs } from '@/content/blog-breadcrumbs';

export function BlogBreadcrumbs({
  category,
  article,
}: {
  category?: string | undefined;
  article?: { title: string; href: string };
}) {
  const items = getBlogBreadcrumbs(category, article);

  return (
    <nav aria-label="Breadcrumb" className="blog-breadcrumbs">
      <ol className="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-xs leading-6 text-ink-500 sm:text-sm">
        {items.map((item, index) => {
          const current = index === items.length - 1;
          return (
            <li
              key={item.href}
              className={`flex min-w-0 items-baseline gap-2 ${current && index > 0 ? 'flex-1 basis-48' : ''}`}
            >
              {index > 0 && (
                <span aria-hidden="true" className="text-ink-300">
                  /
                </span>
              )}
              {current ? (
                <span
                  aria-current="page"
                  className="min-w-0 break-words text-ink-600"
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="rounded-sm transition-colors hover:text-ink-900 hover:underline hover:underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ember-500"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
